module.exports = __webpack_public_path__ + "img/PTP能力验证提供者认可证书.png";